import { Component, OnInit ,Input} from '@angular/core';
import { uploadService } from '../../../../../services/uploadService'
import { Upload } from '../../../../../entities/upload'

import { NewsService } from '../../../../../services/newsService'
@Component({
  selector: 'app-newslist',
  templateUrl: './newslist.component.html',
  styleUrls: ['./newslist.component.css']
})
export class NewslistComponent implements OnInit {

  @Input('data') meals: string[] = [];
  page: number = 1;
  getNewsAll;
  constructor(private nSv: NewsService) { }

  ngOnInit() {
    // // get News
    let getNews = this.nSv.getNewsPomotion();
    getNews.subscribe((snapshot) => {
      this.getNewsAll = snapshot;
    })
  }
  removeNews(idd) {
    this.nSv.removeNews(idd)
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/news/view/newslist/newslist.component.ts